const { serialize } = require("../../utils");
export default {
  namespaced: true,
  state: {
    path: "aljabr/groups",
  },
  actions: {
    get({ dispatch, state, rootState }, options) {
      options["branch"] = rootState.aljabr.selectedBranch._id;
      options["academicYear"] = rootState.aljabr.selectedAcademicYear._id;
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    list({ dispatch, state, rootState }, academicYearID) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/list/?branch=${rootState.aljabr.selectedBranch._id}&academicYear=${academicYearID ? academicYearID : rootState.aljabr.selectedAcademicYear._id}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    last({ dispatch, state, rootState }) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/last/?branch=${rootState.aljabr.selectedBranch._id}&academicYear=${rootState.aljabr.selectedAcademicYear._id}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    add({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        data["branch"] = rootState.aljabr.selectedBranch._id;
        data["academicYear"] = rootState.aljabr.selectedAcademicYear._id;
        data["company"] = { short: rootState.company.short.toLowerCase() };
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/add`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    listWithStudents({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/list-with-students/?branch=${rootState.aljabr.selectedBranch._id}&academicYear=${options.academicYearID ? options.academicYearID : rootState.aljabr.selectedAcademicYear._id}&disableIfNoContract=${options.disableIfNoContract ? options.disableIfNoContract : false}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    save({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/save`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    id({ dispatch, state, rootState }, id) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/id/${id}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    // Rahbarning o'zi shartnomani bekor qilishi (ariza PDF bilan birga ketadi)
    cancelContractByDirector({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/cancel-contract-by-director`,
            method: "VID",
            data,
          },
          { root: true }
        );
      }
    },
    // O'quvchini bir davlat sinfidan boshqasiga ko'chirish
    moveStudentToGroup({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/move-student-to-group`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    removeStudent({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/remove-student`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    requestRemoveStudentPermission({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/request-remove-student-permission`,
            // Ariza (PDF) bilan birga ketadi, shuning uchun FormData — VID
            method: "VID",
            data,
          },
          { root: true }
        );
      }
    },
    addKnowledge({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        data["branch"] = rootState.aljabr.selectedBranch._id;
        data["academicYear"] = rootState.aljabr.selectedAcademicYear._id;
        data["company"] = { short: rootState.company.short.toLowerCase() };
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/add-knowledge`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    getKnowledgeGroups({ dispatch, state, rootState }, options) {
      options["branch"] = rootState.aljabr.selectedBranch._id;
      options["academicYear"] = rootState.aljabr.selectedAcademicYear._id;
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/knowledge-groups?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    saveKnowledge({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/save-knowledge`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    // Davlat sinfi sig'imini tahrirlashga ruxsat so'rash
    sendGroupEditAction({ dispatch, state }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/send-group-edit-action`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    sendKnowledgeGroupEditAction({ dispatch, state }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/send-knowledge-group-edit-action`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    knowledGroupId({ dispatch, state, rootState }, id) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/knowledge-group/${id}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    addTeacherToKnowledgeGroup({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/add-teacher-to-knowledge-group`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    removeTeacherFromKnowledgeGroup({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/remove-teacher-from-knowledge-group`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    addStudentToKnowledgeGroup({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/add-student-to-knowledge-group`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    // Boshqa bilim darajasi guruhiga o'tkazishga ruxsat so'rash
    requestKnowledgeGroupTransfer({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/request-knowledge-group-transfer`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    // O'quvchini boshqa bilim darajasi guruhiga o'tkazish
    moveStudentToKnowledgeGroup({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/move-student-to-knowledge-group`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    removeStudentFromKnowledgeGroup({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/remove-student-from-knowledge-group`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    addScienceToKnowledgeGroup({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/add-science-to-knowledge-group`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    removeScienceFromKnowledgeGroup({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/remove-science-from-knowledge-group`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    listWithStudentsForAddGroup({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/list-with-students-for-add-group?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    remove({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/remove`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    removeKnowledge({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/remove-knowledge`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    addKnowledgeGroupRatings({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/add-knowledge-group-ratings`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    "add-students-notebook-etiquette-evolution"({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/add-students-notebook-etiquette-evolution`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    saveFirstGradeExtraAssessments({ dispatch, state }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/save-first-grade-extra-assessments`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    saveStudentYearEndConclusion({ dispatch, state }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/save-student-year-end-conclusion`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    depositListWithStudents: ({ dispatch, state, rootState }, options) => {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/deposit-list-with-students?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    moveStudentFromDepositToGroup: ({ dispatch, state, rootState }, data) => {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/move-student-from-deposit-to-group`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    getGroupRatingReports: ({ dispatch, state, rootState }, options) => {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/group-rating-reports?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    reInitGroupStudents: ({ dispatch, state, rootState }, data) => {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/re-init-group-students`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    getContractsReport: ({ dispatch, state, rootState }, data) => {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/get-contracts-report`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    getAbsendAnalytics: ({ dispatch, state, rootState }, data) => {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/get-absend-analytics`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    getSavedKnowledgeGroupRatings: ({ dispatch, state, rootState }, options) => {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/get-saved-knowledge-group-ratings?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    saveKnowledgeGroupRatings({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/save-knowledge-group-ratings`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
  },
};
